import '../GlowSubWidgets.css';
import React from "react";

function MorningCheckIn(props) {

    return (
        <div>
            <p> morning check in </p>
        </div>
    )
}

export default MorningCheckIn;